import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import
const Imprint = () => {
     const { t } = useTranslation("Imprint");
    return (
        <div className="col-12 col-lg-11 pb-5">
            <div className=" overflow-hidden order-3">
                <div className=" p-4 p-md-5">
                    <h2 className="fw-600 text-black mb-3">{t("imprint")} </h2>
                    <h4 className="fw-500 text-black mb-3">{t("responsible")} </h4>
                    <p className="fw-700 text-bl fs-7 mb-1">
                       {t("companyName")} 
                    </p>
                    <p className="mb-1 text-bl mb-1"> {t("address")}  18</p>
                    <p className="mb-1 text-bl mb-1"> 81541 {t("munich")} </p>
                    <p className="mb-1 text-bl mb-1"> {t("germany")} </p>
                    <h4 className="fw-500 pt-4">{t("representedBy")} :</h4>
                    <p className="fw-600 text-muted mb-2 fs-7 text-bl mb-4">
                      {t("managingDirector")} 
                    </p>

                    <h4>{t("contact")} :</h4>
                    <h5 className="mb-4">{t("email")} </h5>
                    <h4>{t("registerEntry")} :</h4>
                    <p className="mb-1 text-bl mb-1">
                       {t("registerText")}
                    </p>
                    <p className="mb-1 text-bl mb-1">
                       {t("registerCourt")}
                    </p>
                    <p className="mb-1 text-bl mb-4">
                       {t("registerNumber")} 291236
                    </p>

                    <h4>{t("vatId")}:</h4>
                    <p className="mb-1 text-bl mb-4">
                       {t("vatText")}
                        DE367277219
                    </p>
                    <h4>{t("contentResponsibility")}</h4>
                    <p className="mb-1 text-bl mb-4">{t("seeabove")}</p>
                </div>
            </div>
        </div>
    );
};

export default Imprint;
